/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Remind_MeInputs */

const en_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remind Me`)
};

const ar_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذكّرني`)
};

const de_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erinnere mich`)
};

const es_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuérdamelo`)
};

const fr_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me le rappeler`)
};

const it_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricordamelo`)
};

const ja_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const ko_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미리 알림 받기`)
};

const pt_br_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembre-me`)
};

const ru_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Напомнить`)
};

const th_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เตือนฉัน`)
};

const tr_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatırlat`)
};

const zh_cn_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提醒我`)
};

const zh_tw_btn_remind_me = /** @type {(inputs: Btn_Remind_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提醒我`)
};

/**
* | output |
* | --- |
* | "Remind Me" |
*
* @param {Btn_Remind_MeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_remind_me = /** @type {((inputs?: Btn_Remind_MeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Remind_MeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_remind_me(inputs)
	if (locale === "ar") return ar_btn_remind_me(inputs)
	if (locale === "de") return de_btn_remind_me(inputs)
	if (locale === "es") return es_btn_remind_me(inputs)
	if (locale === "fr") return fr_btn_remind_me(inputs)
	if (locale === "it") return it_btn_remind_me(inputs)
	if (locale === "ja") return ja_btn_remind_me(inputs)
	if (locale === "ko") return ko_btn_remind_me(inputs)
	if (locale === "pt_br") return pt_br_btn_remind_me(inputs)
	if (locale === "ru") return ru_btn_remind_me(inputs)
	if (locale === "th") return th_btn_remind_me(inputs)
	if (locale === "tr") return tr_btn_remind_me(inputs)
	if (locale === "zh_cn") return zh_cn_btn_remind_me(inputs)
	return zh_tw_btn_remind_me(inputs)
});